import { Form, message, Radio, Tooltip } from 'antd';
import TcButton from 'components/UI/button/TcButton';
import TcCheckbox from 'components/UI/Checkbox/TcCheckbox';
import TcForm from 'components/UI/form/TcForm';
import TcFormItem from 'components/UI/form/TcFormItem';
import { createCompanyCustomerForm, createPersonCustomerForm } from 'components/UI/layout/components/emergencyInfos/createCustomerForm';
import TermsAndConditionsModal from 'components/UI/layout/components/emergencyInfos/TermsAndConditionsModal';
import TcModal from 'components/UI/Modal/TcModal';
import endpointUrls from 'global/Constants/endpointUrls';
import { convertFormValuesToEnglishNumber } from 'global/default';
import { handleApiThen, handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { customerCategory } from 'global/Models/userModel';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsUserAllowedToMakeOrder } from 'redux/reducer/user/getIsUserAllowedToMakeOrder';
import { getWhoAmI } from 'redux/reducer/user/getWhoAmI';
import { RootState, store } from 'redux/store';

interface ICreateCustomerModal {
  visible: boolean;
  close(): void;
}

const CreateCustomerModal: FC<ICreateCustomerModal> = ({ visible, close }) => {
  //states
  const { userProfile } = useSelector((state: RootState) => state.user);
  const [categoryChildren, setCategoryChildren] = useState<customerCategory[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [isCompany, setIsCompany] = useState(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [richTextValue, setRichTextValue] = useState<any[]>([]);
  const [showTermsAndCondition, setShowTermsAndCondition] = useState<boolean>(false);

  //hooks
  const [form] = Form.useForm();

  //effect
  useEffect(() => {
    getTermsAndConditions();
  }, [showTermsAndCondition]);

  useEffect(() => {
    if (userProfile) form.setFieldValue('emailAddress', userProfile.email);
    if (userProfile && userProfile.personId) {
      getPerson(userProfile.personId);
      form.setFieldValue('emailAddress', userProfile.email);
      form.setFieldValue('nationalId', userProfile.nationalId);
      form.setFieldValue('mobile', userProfile.mobileNumber);
      form.setFieldValue('fullName', userProfile.fullName);
    }
  }, [userProfile]);

  //functions
  const handleChange = (value: any, values: any) => {
    convertFormValuesToEnglishNumber(value, values, ['nationalId', 'mobile', 'tel', 'finantialCode', 'registrationCode', 'managerMobile'], form, true);
    if (value.referenceId) {
      form.setFieldValue('categoryId', undefined);
      setCategoryChildren(undefined);
      getCategoryChildren(value.referenceId);
    }

    if (value.persinType) setIsCompany(value.persinType === 2);
  };
  const getPerson = async (personId: number) => {
    setLoading(true);
    await ApiService.get(endpointUrls.getPeople + '?id=' + personId)
      .then((res: any) =>
        handleApiThen({
          res,
          notifFail: true,
          dataOnly: true,
          notifSuccess: false,
          onSuccess: (data) => {
            if (data?.personType === 2) setIsCompany(true);
            if (data.individualPerson.firstName) form.setFieldValue('firstName', data.individualPerson.firstName);
            if (data.individualPerson.lastName) form.setFieldValue('lastName', data.individualPerson.lastName);
          },
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };
  const getCategoryChildren = async (referenceId: number) => {
    await ApiService.post(endpointUrls.customerCategoryGetAll, { referenceId })
      .then((res: IBackendSearchGeneric<customerCategory>) =>
        handleApiThenGeneric<IBackendSearchGeneric<customerCategory>, customerCategory[]>({
          res,
          onSuccessData: setCategoryChildren,
          notifFail: false,
          notifSuccess: false,
          onFailed: () => setCategoryChildren(undefined),
        })
      )
      .catch(() => setCategoryChildren(undefined));
  };
  const handleSubmit = async (values: any) => {
    if (!isChecked) return message.error('موافقت با قوانین و ضوابط اجباری اشت.');
    const endpoint = isCompany ? endpointUrls.customerLegalCreate : endpointUrls.customerActualCreate;
    setLoading(true);
    await ApiService.post(endpoint, {
      ...values,
      categoryId: values.categoryId ? values.categoryId : values.referenceId,
      personId: userProfile?.personId,
      isTermsAndConditionsAccepted: true,
    })
      .then((res: any) =>
        handleApiThen({
          res,
          notifFail: true,
          notifSuccess: true,
          onSuccess: () => {
            store.dispatch(getIsUserAllowedToMakeOrder());
            store.dispatch(getWhoAmI());
            close();
          },
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
    return '';
  };

  const getTermsAndConditions = async () => {
    await ApiService.post(endpointUrls.termsAndConditionsGetAll, {})
      .then((res: any) =>
        handleApiThen({
          res,
          onSuccess: (res) => {
            const terms = res.data.find((term: any) => term.termsAndConditionsTypeId == 1);
            if (terms) {
              setRichTextValue(JSON.parse(terms.content));
            } else {
              setRichTextValue([]);
            }
          },
          notifFail: false,
          notifSuccess: false,
          onFailed: () => setRichTextValue([]),
        })
      )
      .catch(() => localApiCatcher(errorResponse));
  };

  return (
    <>
      <TcModal title='تکمیل اطلاعات حساب' width={768} footer={false} onCancel={close} visible={visible}>
        {/* {userProfile?.personId && (
        <div>
          <TcDevider className='mt-0'>اطلاعات فردی</TcDevider>
          <TcShowInfo right='نام' left={userProfile?.fullName} />
          <TcShowInfo right='ایمیل' left={userProfile?.email} />
          <TcShowInfo right='کد ملی' left={userProfile?.nationalId} />
          <TcShowInfo right='شماره موبایل' left={userProfile?.mobileNumber} />
          <div className='flex justify-end mt-4'>
            <Link to={routes.userProfile.path} className='w-full'>
              <TcButton className='w-full' onClick={close}>
                ویرایش اطلاعات فردی
              </TcButton>
            </Link>
          </div>
        </div>
      )} */}

        <div>
          {/* <TcDevider>اطلاعات مشتری</TcDevider> */}
          <TcForm form={form} onValuesChange={handleChange} onFinish={handleSubmit}>
            <TcFormItem label='نوع حساب' initialValue={1} name='persinType'>
              <Radio.Group defaultValue={1}>
                <Radio value={1}>حقیقی</Radio>
                <Radio value={2}>حقوقی</Radio>
              </Radio.Group>
            </TcFormItem>
            {!isCompany && createPersonCustomerForm(categoryChildren)}
            {isCompany && createCompanyCustomerForm(categoryChildren)}

            <div className='flex items-center mt-8 '>
              <div className='flex items-center gap-2'>
                <TcCheckbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} id='isCheckedTermsAndConditions' />
                <label className='flex items-center text-sm select-none ' htmlFor='isCheckedTermsAndConditions'>
                  شرایط و قوانین را مطالعه کرده و موافقم.
                </label>
              </div>
              <Tooltip title='جزئیات'>
                <div onClick={() => setShowTermsAndCondition(true)} className='mx-1 text-xs cursor-pointer bg-inherit text-t-primary-color'>
                  {' '}
                  ( مشاهده جزئیات ){' '}
                </div>
              </Tooltip>
            </div>
            <div className='mt-10'>
              <TcButton type='primary' className='w-full' loading={loading} htmlType='submit'>
                تایید اطلاعات
              </TcButton>
            </div>
          </TcForm>
        </div>
      </TcModal>

      <TermsAndConditionsModal visible={showTermsAndCondition} close={() => setShowTermsAndCondition(false)} richTextValue={richTextValue} />
    </>
  );
};

export default CreateCustomerModal;
